import React from "react";
import notify from "devextreme/ui/notify";
import Form, {
  SimpleItem,
  GroupItem,
  Label,
  EmptyItem,
} from "devextreme-react/form";
import "devextreme-react/text-area";
import UserInfo from "../../UserInfo";
import {
  criarEncerramentoFiscalManualDs,
  criarCpbsDs,
} from "../../DataSources";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import CpbsBox from "../cpbs/CpbsBox";
import { Button, ScrollView } from "devextreme-react";
import sysCodigoDescricao from "../../components/sysCodigoDescricao";
import uiInfo from "../../ui-info";
import api from "../../api-axios";
import ShowError from "../../AppServices";

const template = {
  id: undefined,
  prefeituraId: UserInfo.getPrefeitura(),
  cpbsId: undefined,
  cpbsSequencial: undefined,
  exercicio: new Date().getFullYear(),
  mes: undefined,
  nomeArquivo: undefined,
  totalIss: 0.0,
  totalBC: 0.0,
  multa: 0.0,
  juros: 0.0,
  correcao: 0.0,
  motivoValorAdicional: undefined,
  valorAdicional: 0.0,
  damCompensado: undefined,
  valorCompensado: 0.0,
  valorAtual: 0.0,
  popupCpbsVisivel: false,
};

export default class EncerramentoFiscalManualForm extends React.Component {
  constructor(props) {
    super(props);
    this.encerramentoFiscalDs = criarEncerramentoFiscalManualDs();
    this.ok = this.ok.bind(this);
    this.cancel = this.cancel.bind(this);
    this.saidaProgramada = false;
    template.prefeituraId = UserInfo.getPrefeitura();
    this.state = { ...template };

    this.cpbsBoxRef = React.createRef();
    this.onCpbsSelecionado = this.onCpbsSelecionado.bind(this);
    this.setCpbsId = this.setCpbsId.bind(this);
    this.atualizarNomeCpbs = this.atualizarNomeCpbs.bind(this);
    this.atualizaSequencialNomeCpbs =
      this.atualizaSequencialNomeCpbs.bind(this);
    this.cpbsDs = criarCpbsDs();
    this.onCpbsPesquisa = this.onCpbsPesquisa.bind(this);
    this.handleValorAtualChange = this.handleValorAtualChange.bind(this);

    this.renderCpbs = sysCodigoDescricao(
      () => this.state.cpbsSequencial,
      this.setCpbsId,
      () => this.state._uiCpbsNome,
      this.onCpbsPesquisa
    );

    this.mesOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: uiInfo.listaMeses,
      valueExpr: "id",
      displayExpr: "mes",
    };
  }

  setCpbsId(e) {
    this.setState({ cpbsSequencial: e.value });
    this.atualizarNomeCpbs();
  }

  atualizarNomeCpbs() {
    this.cpbsDs
      .load({ filter: [["sequencial", "=", this.state.cpbsSequencial]] })
      .then((result) => {
        if (result.length !== 0 && result[0]) {
          this.setState({
            cpbsId: result[0].id,
            cpbsSequencial: result[0].sequencial.toString(),
            _uiCpbsNome: result[0].contribuinte.nome,
          });
        } else {
          this.setState({
            cpbsId: this.state.cpbsSequencial,
            cpbsSequencial: this.state.cpbsSequencial.toString(),
            _uiCpbsNome: "",
          });
        }
      })
      .catch((_) => {
        this.setState({
          cpbsId: this.state.cpbsSequencial,
          cpbsSequencial: this.state.cpbsSequencial.toString(),
          _uiCpbsNome: "<< ERRO >>",
        });
        console.log(_);
      });
  }

  onCpbsSelecionado(e) {
    this.setState({
      cpbsSequencial: e.row.data.sequencial.toString(),
      popupCpbsVisivel: false,
    });
    this.atualizarNomeCpbs();
  }

  onCpbsPesquisa(e) {
    this.setState({ popupCpbsVisivel: true });
  }

  atualizaSequencialNomeCpbs() {
    this.cpbsDs
      .load({ filter: [["id", "=", this.state.cpbsId]] })
      .then((result) => {
        if (result.length !== 0 && result[0]) {
          this.setState({
            cpbsSequencial: result[0].sequencial.toString(),
            _uiCpbsNome: result[0].contribuinte.nome,
          });
        } else {
          this.setState({
            cpbsId: this.state.cpbsId,
            cpbsSequencial: this.state.cpbsId,
            _uiCpbsNome: "<< ERRO >>",
          });
        }
      })
      .catch((_) => this.setDadosCpbs(null));
  }

  handleValorAtualChange() {
    let totalIss = this.state.totalIss ? this.state.totalIss : 0;
    let multa = this.state.multa ? this.state.multa : 0;
    let juros = this.state.juros ? this.state.juros : 0;
    let correcao = this.state.correcao ? this.state.correcao : 0;
    let valorAdicional = this.state.valorAdicional
      ? this.state.valorAdicional
      : 0;
    let valorCompensado = this.state.valorCompensado
      ? this.state.valorCompensado
      : 0;

    let valorAtual =
      totalIss + multa + juros + correcao + valorAdicional - valorCompensado;

    this.setState({ valorAtual });
  }

  componentDidMount() {
    if (this.props.match.params.id !== undefined) {
      api
        .get(`/iss_ifs/obter_cadastro_manual/${this.props.match.params.id}`)
        .then(({ data }) => {
          console.log(data);
          if (data === undefined) {
            notify("Registro não encontrado.", "error");
            this.props.history.push("/encerramento-fiscal");
          }
          this.setState({
            ...data,
          });
          this.atualizaSequencialNomeCpbs();
        })
        .catch((error) => {
          ShowError(error.response.data);
          notify(error, "error", 2000);
          this.props.history.goBack();
        });
    } else {
      this.setState({ ...template });
    }
  }

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <form>
            <Form formData={this.state} colCount={2} labelLocation="top">
              <GroupItem
                caption="CADASTRO MANUAL DE ENCERRAMENTO FISCAL"
                colSpan={2}
                colCount={4}
              >
                <SimpleItem colSpan={4} component={this.renderCpbs}>
                  <Label text="CPBS" />
                </SimpleItem>
                <SimpleItem
                  dataField={"exercicio"}
                  colSpan={1}
                  editorType={"dxNumberBox"}
                >
                  <Label text="Exercício" />
                </SimpleItem>
                <SimpleItem
                  dataField={"mes"}
                  colSpan={1}
                  editorType={"dxLookup"}
                  editorOptions={this.mesOptions}
                >
                  <Label text="Mês" />
                </SimpleItem>
                <SimpleItem dataField={"nomeArquivo"} colSpan={2}>
                  <Label text="Nome do Arquivo" />
                </SimpleItem>
                <SimpleItem
                  dataField={"totalIss"}
                  colSpan={1}
                  editorType={"dxNumberBox"}
                  editorOptions={{
                    format: uiInfo.formatoNumerico.n2,
                    onValueChanged: () => this.handleValorAtualChange(),
                  }}
                  cssClass={"txtFrmCpbsNumerico"}
                >
                  <Label text="Total ISS" />
                </SimpleItem>
                <SimpleItem
                  dataField={"totalBC"}
                  colSpan={1}
                  editorType={"dxNumberBox"}
                  editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
                  cssClass={"txtFrmCpbsNumerico"}
                >
                  <Label text="Total BC" />
                </SimpleItem>
                <EmptyItem colSpan={2} />
                <SimpleItem
                  dataField={"multa"}
                  colSpan={1}
                  editorType={"dxNumberBox"}
                  editorOptions={{
                    format: uiInfo.formatoNumerico.n2,
                    onValueChanged: () => this.handleValorAtualChange(),
                  }}
                  cssClass={"txtFrmCpbsNumerico"}
                >
                  <Label text="Multa" />
                </SimpleItem>
                <SimpleItem
                  dataField={"juros"}
                  colSpan={1}
                  editorType={"dxNumberBox"}
                  editorOptions={{
                    format: uiInfo.formatoNumerico.n2,
                    onValueChanged: () => this.handleValorAtualChange(),
                  }}
                  cssClass={"txtFrmCpbsNumerico"}
                >
                  <Label text="Juros" />
                </SimpleItem>
                <SimpleItem
                  dataField={"correcao"}
                  colSpan={1}
                  editorType={"dxNumberBox"}
                  editorOptions={{
                    format: uiInfo.formatoNumerico.n2,
                    onValueChanged: () => this.handleValorAtualChange(),
                  }}
                  cssClass={"txtFrmCpbsNumerico"}
                >
                  <Label text="Correção" />
                </SimpleItem>
                <EmptyItem colSpan={1} />
                <SimpleItem
                  dataField={"valorAdicional"}
                  colSpan={1}
                  editorType={"dxNumberBox"}
                  editorOptions={{
                    format: uiInfo.formatoNumerico.n2,
                    onValueChanged: () => this.handleValorAtualChange(),
                  }}
                  cssClass={"txtFrmCpbsNumerico"}
                >
                  <Label text="Valor Adicional" />
                </SimpleItem>
                <SimpleItem dataField={"motivoValorAdicional"} colSpan={3}>
                  <Label text="Motivo Valor Adicional" />
                </SimpleItem>
                <SimpleItem
                  dataField={"valorCompensado"}
                  colSpan={1}
                  editorType={"dxNumberBox"}
                  editorOptions={{
                    format: uiInfo.formatoNumerico.n2,
                    onValueChanged: () => this.handleValorAtualChange(),
                  }}
                  cssClass={"txtFrmCpbsNumerico"}
                >
                  <Label text="Valor Compensado" />
                </SimpleItem>
                <SimpleItem dataField={"damCompensado"} colSpan={3}>
                  <Label text="Dam Compensado" />
                </SimpleItem>
                <SimpleItem
                  dataField={"valorAtual"}
                  colSpan={1}
                  editorType={"dxNumberBox"}
                  editorOptions={{
                    format: uiInfo.formatoNumerico.n2,
                    disabled: true,
                  }}
                  cssClass={"txtFrmCpbsNumerico"}
                >
                  <Label text="Valor Atual" />
                </SimpleItem>
                <EmptyItem colSpan={3} />
                <SimpleItem
                  dataField={"observacao"}
                  editorType={"dxTextArea"}
                  editorOptions={{ height: "80px" }}
                  colSpan={4}
                >
                  <Label text="Observação" />
                </SimpleItem>
              </GroupItem>
            </Form>
            <div style={{ marginTop: "10px" }}>
              <div style={{ display: "inline-block" }}>
                <Button
                  width={120}
                  text="Salvar"
                  type="success"
                  onClick={this.ok}
                />
              </div>
              <div style={{ display: "inline-block", marginLeft: "10px" }}>
                <Button text="Cancelar" onClick={this.cancel} />
              </div>
            </div>
          </form>
          <Popup
            visible={this.state.popupCpbsVisivel}
            onHiding={() => this.setState({ popupCpbsVisivel: false })}
            dragEnabled={false}
            closeOnOutsideClick={true}
            showCloseButton={true}
            showTitle={true}
            width={"90%"}
            height={"90%"}
            title="Pesquisar CPBS"
          >
            <ScrollView showScrollbar={"always"}>
              <CpbsBox
                onSelecionado={this.onCpbsSelecionado}
                ref={this.cpbsBoxRef}
              />
            </ScrollView>

            <ToolbarItem
              toolbar={"bottom"}
              widget="dxButton"
              location="center"
              options={{
                text: "Fechar",
                type: "default",
                width: 150,
                onClick: () => this.setState({ popupCpbsVisivel: false }),
              }}
            ></ToolbarItem>
          </Popup>
        </div>
      </React.Fragment>
    );
  }

  ok() {
    const entidade = this.state;
    if (this.props.match.params.id) {
      api
        .put(
          `/iss_ifs/edicao_cadastro_manual/${this.props.match.params.id}`,
          entidade
        )
        .then(
          function () {
            notify("Encerramento Fiscal atualizado com sucesso.", "success");
            this.props.history.goBack();
          }.bind(this)
        )
        .catch((error) => {
          ShowError(error.response.data);
          notify(error, "error", 2000);
        });
    } else {
      api
        .post(`/iss_ifs/cadastro_manual/`, entidade)
        .then(
          function () {
            notify("Encerramento Fiscal atualizado com sucesso.", "success");
            this.props.history.goBack();
          }.bind(this)
        )
        .catch((error) => {
          ShowError(error.response.data);
          notify(error, "error", 2000);
        });
    }
  }

  cancel() {
    notify("Operação cancelada", "warning");
    this.props.history.goBack();
  }
}
